var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect, useRef } from "react";
import { FixedSizeList as List, } from "react-window";
import { default as InfiniteLoaderWrapper } from "react-window-infinite-loader";
import { FTLDots } from "../FTLDots";
import { Box } from "@material-ui/core";
import { FTLTypography } from "../FTLTypography";
class InfiniteListState {
    constructor(items) {
        this.items = items;
        this.loaded = false;
        this.page = 0;
    }
}
export function InfiniteLoader(props) {
    const [state, updateState] = useState(new InfiniteListState([]));
    const infiniteLoaderRef = useRef(null);
    const itemRenderer = (lp) => {
        let content;
        if (isItemLoaded(lp.index)) {
            content = {
                data: state.items[lp.index],
                index: lp.index,
                isScrolling: lp.isScrolling,
                style: lp.style,
            };
        }
        else {
            content = {
                data: {
                    type: "loading",
                    component: React.createElement(FTLDots, { color: "tertiary" }),
                },
                index: lp.index,
                isScrolling: lp.isScrolling,
                style: lp.style,
            };
        }
        return props.itemRenderer(content);
    };
    const records = props.records || 10;
    const itemCount = props.itemCount
        ? props.itemCount
        : state.loaded
            ? state.items.length
            : state.items.length + 1;
    const height = props.height || itemCount < records
        ? itemCount * props.itemSize
        : records * props.itemSize;
    const width = props.width || "100%";
    const loadNextPage = (startIndex, stopIndex) => __awaiter(this, void 0, void 0, function* () {
        const page = state.page + 1;
        const { items } = yield props.loadItems(startIndex, stopIndex || startIndex + records);
        let normalizedItems;
        if (props.normalizeScheme && items) {
            const normalizeScheme = props.normalizeScheme;
            normalizedItems = items.map((item) => {
                let obj = {};
                Object.keys(normalizeScheme).forEach((key) => {
                    const value = normalizeScheme[key];
                    if (value instanceof Function)
                        obj[key] = value(item);
                    else
                        obj[key] = item[value];
                });
                return obj;
            });
        }
        else {
            normalizedItems = items;
        }
        if (props.queryValue)
            state.items = [...normalizedItems];
        else
            state.items.push(...normalizedItems);
        const newState = new InfiniteListState(state.items);
        newState.page = page;
        newState.loaded = items.length < records;
        updateState(newState);
    });
    const itemKey = (index, data) => {
        const field = props.itemKey || "id";
        if (data == null || data[field] == null)
            return index;
        return data[field];
    };
    const isItemLoaded = (index) => {
        return state.loaded || index < state.items.length;
    };
    useEffect(() => {
        loadNextPage(0);
    }, [props.queryValue]);
    return state.items.length ? (React.createElement(InfiniteLoaderWrapper, { ref: infiniteLoaderRef, isItemLoaded: isItemLoaded, itemCount: itemCount, 
        //@ts-ignore
        loadMoreItems: loadNextPage, minimumBatchSize: 5, threshold: 5 }, ({ onItemsRendered, ref }) => (React.createElement(List, { ref: ref, itemCount: itemCount, onItemsRendered: onItemsRendered, itemKey: itemKey, initialScrollOffset: props.initialScrollOffset, itemSize: props.itemSize, width: width, height: height }, itemRenderer)))) : (React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center", height: 32 }, props.queryValue || (state.items.length === 0 && state.loaded) ? (React.createElement(FTLTypography, { color: "secondary" }, props.queryValue ? "Ничего не найдено" : "Нет данных")) : (React.createElement(FTLDots, { color: "dark" }))));
}
//# sourceMappingURL=InfiniteLoader.js.map